import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { getCreditCardAccount } from "./getCreditCardAccount";
import { Account } from "./types";

interface Params {
  accountId: string;
  enabled: boolean;
  initialData: Account;
}

export const useCreditCardAccount = ({
  accountId,
  enabled,
  initialData,
}: Params) =>
  useQuery<Account, AxiosError>(
    ["account", { accountId }],
    () => getCreditCardAccount(accountId),
    {
      ...(enabled === undefined ? {} : { enabled }),
      ...(initialData === undefined ? {} : { initialData }),
    },
  );
